import { Flex } from "@capioweb/ui-components/src/components/Flex"
import { Icon } from "@capioweb/ui-components/src/components/Icon"
import * as React from "react"
import styled from "styled-components"
import { ChildrenProps } from "../../@types/CapioWeb/core"
import { sendCareerListBlockClickDataLayerPush } from "../../utils"

export interface ButtonListItemProps {
	onClick: () => void
}

export interface ListItemProps {
	href: string
	text?: string
	date?: string
	children?: React.ReactNode
}

export interface ListComponent {
	Item: React.FC<ListItemProps>
}

const List: React.FC<ChildrenProps> & ListComponent = ({ children }) => (
	<Flex as={"ul"} flexDirection={"column"} width={"100%"}>
		{React.Children.map(children, (child, index) => {
			return (
				<Flex
					as="li"
					borderTop
					borderBottom={index === React.Children.count(children) - 1}
				>
					{child}
				</Flex>
			)
		})}
	</Flex>
)

const StyledClickableItem = styled(Flex)`
	&:hover a {
		color: green;
	}
`

List.Item = ({ children, href, text, date }) => {
	return (
		<Flex width={"100%"}>
			<StyledClickableItem
				as={"a"}
				alignItems={"center"}
				flexDirection={"row"}
				justifyContent={"space-between"}
				width={"100%"}
				py={1}
				px={{ m: 1 }}
				href={href}
				onClick={
					text
						? () => sendCareerListBlockClickDataLayerPush(text, date ?? "")
						: null
				}
			>
				<div>{children}</div>
				<Icon color={"navy"} icon="arrow-right" mr={1} size={2} />
			</StyledClickableItem>
		</Flex>
	)
}

export { List }
